/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: i18n.js
 * Created by: chan.ying
 * Create Date: 2026-04-27 15:52
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import {reactive} from "vue";
import {createI18n} from "vue-i18n";
import Log from "@/commons/logs/Log";
import ProfileData from "@/utils/cookie/ProfileData";
// import CookieUtil from "@/utils/cookie/CookieUtil";

export function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

export const _KeyCurrentLanguage = "key_current_language"
export const SupportedLanguageFlags = {
    US: require("@/assets/images/flags/us.jpg"),
    CN: require("@/assets/images/flags/china.png"),
}
export const SupportedLanguageNames = {
    US: "English",
    ZhCN: "中文简体",
}

export const SupportedLanguageKeys = {
    US: "en-US",
    ZhCN: "zh-CN",
}

export const SupportedLanguageValues = {
    US: 0,
    ZhCN: 1,
}

export const SupportedLanguages = [
    {
        flag: SupportedLanguageFlags.US,
        language: SupportedLanguageKeys.US,
        title: SupportedLanguageNames.US,
        value: SupportedLanguageValues.US,
    },
    {
        flag: SupportedLanguageFlags.CN,
        language: SupportedLanguageKeys.ZhCN,
        title: SupportedLanguageNames.ZhCN,
        value: SupportedLanguageValues.ZhCN,
    },
]

export const getCurrentLanguage = function () {
    return ProfileData.getLanguage();
}

export const setCurrentLanguage = (i18n, langValue) => {
    const lang = SupportedLanguages.find(l => l.value === langValue)
    if (lang) {
        i18n.global.locale.value = lang.language
        // CookieUtil.setRawCookie(_KeyCurrentLanguage, lang.language)

        if (!i18n.currentLanguage) {
            i18n.currentLanguage = reactive({ flag: '', title: '' })
        }
        i18n.currentLanguage.flag = lang.flag
        i18n.currentLanguage.title = lang.title

        Log.debug("set current lang to => " + lang.language)
    }
}

export const getCurrentLanguageFlag = function () {
    switch (getCurrentLanguage()) {
        case SupportedLanguageValues.US: {
            return SupportedLanguageFlags.US
        }
        case SupportedLanguageValues.ZhCN: {
            return SupportedLanguageFlags.CN
        }
    }
    return SupportedLanguageFlags.US
}

export const getCurrentLanguageName = function () {
    switch (getCurrentLanguage()) {
        case SupportedLanguageValues.US: {
            return SupportedLanguageNames.US
        }
        case SupportedLanguageValues.ZhCN: {
            return SupportedLanguageNames.ZhCN
        }
    }
    return SupportedLanguageNames.US
}

export const i18n = createI18n({
    locale: getCurrentLanguage() === SupportedLanguageValues.US ? SupportedLanguageKeys.US : SupportedLanguageKeys.ZhCN,
    legacy: false,
    globalInjection: true,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-US',
    messages: loadLocaleMessages()
})

export function replaceEveryone(str) {
    const t = i18n.global.t
    return str.replace(/Everyone/g, t('data.team.group_list.def_grp_desc.everyone'))
}